import React, { useState, useEffect, useCallback } from 'react';
import './Hero.css';
import heroimage1 from '../components/Images/shona2.jpeg';
import heroimage2 from '../components/Images/banner2.jpeg';

const slides = [
  {
    image: heroimage1,
    heading: 'Welcome to VegBox',
    subheading: 'High quality, tailored for you, order now',
    cta: 'Shop Now',
  },
  {
    image: heroimage2,
    heading: 'Freshly Baked for You',
    subheading: 'Cakes, Cupcakes & Treats for your special events',
    cta: 'Shop Now',
  },
  // Add more slides here as needed
];

const Hero = () => {
  const [current, setCurrent] = useState(0);
  const [paused, setPaused] = useState(false);

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % slides.length);
  }, []);

  useEffect(() => {
    if (paused) return;
    const timer = setInterval(next, 4000);
    return () => clearInterval(timer);
  }, [paused, next]);

  return (
    <div
      className="hero-carousel"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      {slides.map((slide, idx) => (
        <div
          key={idx}
          className={`hero-slide ${idx === current ? 'active' : ''}`}
        >
          <div className="hero-slide-inner">
            <div className="hero-text">
              <h2>{slide.heading}</h2>
              <h3>{slide.subheading}</h3>
              <button
                className="cta"
                onClick={() =>
                  document
                    .getElementById('products')
                    ?.scrollIntoView({ behavior: 'smooth' })
                }
              >
                {slide.cta}
              </button>
            </div>
            <div className="hero-image-wrap">
              <img src={slide.image} alt={slide.heading} className="hero-img" />
            </div>
          </div>
        </div>
      ))}

      {/* Dot indicators */}
      <div className="hero-dots">
        {slides.map((_, idx) => (
          <button
            key={idx}
            className={`hero-dot ${idx === current ? 'active' : ''}`}
            onClick={() => setCurrent(idx)}
            aria-label={`Slide ${idx + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default Hero;
